package com.videoanalyzer.web.util

import com.videoanalyzer.web.config.Config

/**
 * Debug-only logger that's silent in production.
 *
 * Uses Config.DEBUG_MODE to determine if logs should be printed.
 * Set DEBUG_MODE = false before deploying to production.
 */
object Logger {

    /**
     * Log info message (only in debug mode).
     */
    fun log(message: String) {
        if (Config.DEBUG_MODE) {
            console.log(message)
        }
    }

    /**
     * Log info message with tag (only in debug mode).
     */
    fun log(tag: String, message: String) {
        if (Config.DEBUG_MODE) {
            console.log("[$tag] $message")
        }
    }

    /**
     * Log warning message (only in debug mode).
     */
    fun warn(message: String) {
        if (Config.DEBUG_MODE) {
            console.warn(message)
        }
    }

    /**
     * Log error message (only in debug mode).
     * Note: Actual errors should be reported via ApiClient.reportError()
     */
    fun error(message: String) {
        if (Config.DEBUG_MODE) {
            console.error(message)
        }
    }

    /**
     * Log error with exception (only in debug mode).
     */
    fun error(message: String, throwable: Throwable?) {
        if (Config.DEBUG_MODE) {
            console.error("$message: ${throwable?.message}")
        }
    }
}
